<template>
  <v-main>
    <PageWrapper class="pa-0">
      <PageContent>
        <v-row no-gutters align="center" justify="start" class="pa-4">
          <v-col cols="12" class="mt-4">
            <v-expansion-panels
              v-model="panel">
              <v-expansion-panel value="0">
                <v-expansion-panel-header>
                  Filtros
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-row>
                    <v-col
                      class="d-flex justify-center align-center"
                      cols="3"
                    >
                    <v-checkbox
                      v-model="filter.somenteNaoPagos"
                      :label="`Somente não recebidos`"
                    ></v-checkbox>
                    </v-col>
                      <v-col
                        class="d-flex justify-center align-center"
                        cols="3"
                      >
                        <v-select
                          v-model="idObra"
                          :items="getAllObrasCustom"
                          :item-text="'nome'"
                          :disabled="disabledObra"
                          :item-value="'id'"
                          outlined
                          label="Unidades"
                        ></v-select>
                      </v-col>
                      <v-col
                        class="d-flex"
                        cols="3"
                      >
                      <v-text-field
                        v-model="data_inicio"
                        v-mask="'##/##/####'"
                        required
                        label="De"
                        outlined
                      ></v-text-field>
                      </v-col>
                      <v-col
                        class="d-flex"
                        cols="3"
                      >
                        <v-text-field
                          v-model="data_fim"
                          v-mask="'##/##/####'"
                          required
                          label="Até"
                          outlined
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" class="d-flex justify-end align-end pb-8">
                        <v-btn
                          color="#27997c"
                          dark
                          class="mb-2"
                          @click="searchByFilter"
                        >
                        <v-icon>mdi-magnify</v-icon>
                          Pesquisar
                        </v-btn>
                      </v-col>
                  </v-row>

                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-col>
        </v-row>
        <div class="mb-2 btn-new"> 
          <v-btn
            color="#27997c"
            dark
            class="mb-2"
            @click="openDialog = !openDialog"
            v-on="on"
          >
          <v-icon>mdi-plus</v-icon>  
            Adicionar Novo
          </v-btn>
        </div>
        <v-data-table
        :headers="headers"
        :items="filteredAllBoletos"
        :search="search"
        :loading="loading"
          class="elevation-1"
        >
          <template v-slot:top>
            <v-toolbar
              flat
            >
              <v-toolbar-title>Listagem de Valores</v-toolbar-title>
              <v-divider
                class="mx-4"
                inset
                vertical
              ></v-divider>
              <v-spacer></v-spacer>
              <v-text-field
                v-model="search"
                dense
                outlined
                label="Buscar"
                append-icon="mdi-magnify"
              ></v-text-field>
                  
            </v-toolbar>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-icon
              color="warning"
              small
              class="mr-2"
              @click="editItem(item)"
            >
              mdi-pencil
            </v-icon>
            <v-icon
              color="red"
              small
              @click="deleteItem(item)"
            >
              mdi-delete
            </v-icon>
          </template>
          <template v-slot:no-data>
            <span>Sem dados disponíveis</span>
        </template>
        </v-data-table>
        <AddModalVue :openDialog="openDialog" @closeModal="closeModal" @searchByFilter="searchByFilter" />
        <EditModal :objValue="objEdit" :dialogEdit="dialogEdit" @closeEditItem="closeEditItem" />
        <DeleteModal :dialogDelete="dialogDelete" :objValue="objEdit" @deleteItemConfirm="deleteItemConfirm" @closeDelete="closeDelete" />
      </PageContent>
    </PageWrapper>
  </v-main>
</template>

<script>
import PageWrapper from '@/components/template/PageWrapper.vue';
import PageContent from '@/components/template/PageContent.vue';
import { mapGetters, mapActions } from 'vuex';
import AddModalVue from './AddModal.vue'
import EditModal from './EditModal.vue'
import DeleteModal from './DeleteModal.vue'
import user from '@/utils/user.json';
  export default {
    components:{
    PageWrapper,
    PageContent,
    AddModalVue,
    EditModal,
    DeleteModal
  },
    data: () => ({
      search:'',
      openDialog: false,
      dialogEdit:false,
      dialogDelete: false,
      loading:false,
      objEdit:{},
      filter:{
        somenteNaoPagos: true,
        user
      },
      data_inicio: '',
      data_fim: '',
      idObra: '',
      disabledObra: false,
      headers: [
        { text: 'Empresa', value: 'empresa.nome',  sortable: false,  align: 'center', },
        { text: 'Descrição Manual', value: 'descricao',  sortable: false,  align: 'start', },
        { text: 'Parcelamento', value: 'parcela',  sortable: false,  align: 'start', },
        { text: 'Obras', value: 'obra.nome',  sortable: false,  align: 'center',  },
        { text: 'NFE', value: 'nfe',  sortable: false,  align: 'center',  },
        { text: 'Data de vencimento', value: 'data_vencimento',  sortable: false,  align: 'start', },
        { text: 'Valor', value: 'valor',  sortable: false,  align: 'start', },
        { text: 'Ações', value: 'actions', sortable: false, align: 'start',}
      ],
      obras: [],
      editedIndex: -1,
    }),
    computed: {
      ...mapGetters('obra', {getObras:'getList'}),
      ...mapGetters('valor',['getList']),
      getAllObrasCustom(){
        const email = localStorage.getItem("email_logged");
        const userLogged = user.find((item)=> item.email == email);
        if(userLogged.obras && this.filter){
          this.disabledObra = true;
          this.idObra = userLogged.obras[0];
          return this.getObras.filter((item)=>{
            const obrasPermitidas = userLogged.obras;
            return obrasPermitidas.find((itemId)=> item.id === itemId)
          });
        }

        return this.getObras;
      },
      filteredAllBoletos(){
        
        const list = Object.assign([], this.getList.map((item )=>{
          return {
            ...item,
            dataVencimentoObj: this.transformDateFormat(item.data_vencimento)
          }
        }));
        const listOrdered = list.sort(function(a,b){
          return a.dataVencimentoObj - b.dataVencimentoObj ;
        });
        if( listOrdered && listOrdered.length > 0){
          const total = this.getList.map(item => Number(item.valor ? item.valor : 0) )
          .reduce((acumulado, valorAtual) => acumulado + valorAtual);
          listOrdered.push({
              pessoa:{
                nome: ''
              },
              obra:{
                nome: '- '
              },
              data: 'Total',
              valor: this.formatarMoedaBRL(total),
              actions: ''
          })
        }
        else
          return []

        return listOrdered
      },
    },
    async created () {
       await this.getAllEmpresas();
       await this.getAllObras();
       //await this.getValoresByFilter();
    },
    methods: {
      ...mapActions('empresa', {getAllEmpresas:'getAllEmpresas'}),
      ...mapActions('valor', ['getValoresByFilter']),
      ...mapActions('obra', {getAllObras:'getAllObras'}),
      transformDateFormat(dateString) {
        let dateParts = dateString.split("/");
        return new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]);
      },
      formatarMoedaBRL(valor) {
        const formatter = new Intl.NumberFormat('pt-BR', {
          style: 'currency',
          currency: 'BRL',
        });
        return formatter.format(valor);
      },
      formatToDatastamp(dateStr){
            // Split the date string into parts
        const [day, month, year] = dateStr.split('/').map(Number);

        // Create a new Date object
        const dateObj = new Date(year, month - 1, day); // month - 1 because JavaScript months are 0-indexed

        // Convert to timestamp (milliseconds since Unix epoch)
        const timestamp = dateObj.getTime();
        return timestamp;
      },
      async searchByFilter() {
        const filter = {
          dataInicio: this.formatToDatastamp(this.data_inicio),
          dataFim: this.formatToDatastamp(this.data_fim),
          idObra: this.idObra,
          isPago: this.filter.somenteNaoPagos
        }
        await this.getValoresByFilter(filter)
      },
      initialize () {
        this.obras = ['']
      },
      deleteItem (item) {
        this.objEdit = Object.assign({}, item)
        this.dialogDelete = true
      },
      deleteItemConfirm () {
        this.getList.splice(this.editedIndex, 1)
        this.closeDelete()
      },
      editItem (item) {
          this.objEdit = Object.assign({}, item)
          this.dialogEdit = true
        },
     // edit (item) {
     //   this.dialogEdit = true
     //   this.objEdit = item
     // },
      closeDelete () {
         this.dialogDelete = false;
      },
      closeEditItem () {
         this.dialogEdit = false;
      },
      closeModal () {
        this.openDialog = false;
      },
      close () {
        this.dialog = true
        /*this.$nextTick(() => {
            this.editedItem = Object.assign({}, this.defaultItem)
            this.editedIndex = -1
        })*/
      },
    },
  }
</script>

<style>
.v-text-field.v-text-field--enclosed .v-text-field__details {
  padding-top: 0px;
  margin-bottom: 0px !important; 
}
.menu {
  width: 80%;
  padding-top: 70px;
  position: absolute;
}
.btn-new{
  margin-right: 24px;
  padding-top: 10px;
  justify-content: flex-end;
  display: flex;
}
.title-card{
  background: #272727;
  color: white;
  padding: 20px !important;
}
.v-card__text {
  padding-top: 20px !important;
}
</style>